import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import loadable from "@loadable/component"

import "./tecnologia.scss"

const CarouselSplide = loadable(() => import("../../Carousel/index"))

export const TecnologiaSection = ({ classTitle }) => {
  return (
    <>
      <section className={`${classTitle}-tecnologia-section`} id="Tecnologia">
        <div className={`${classTitle}-tecnologia-title-container`}>
          <div
            className={`${classTitle}-tecnologia-title`}
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <h2>Tenemos la mejor tecnología del mercado actual</h2>
          </div>
        </div>

        <div
          className={`${classTitle}-tecnologia-items-container carousel-container-767`}
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <div
            className={`${classTitle}-tecnologia-item ${classTitle}-tecnologia-item-nuestra`}
          >
            <StaticImage
              src="../../../images/home/tecnologias/Tecnología.png"
              alt={`${classTitle}-tecnologia-image`}
              className={`${classTitle}-tecnologia-image`}
              placeholder="blurred"
            />
            <h5>Nuestra tecnología</h5>
            <p>
              Contamos con personal propio y una amplia red de colaboradores
              externos, todos ellos expertos profesionales equipados con
              tecnología de última generación.
            </p>
          </div>
          <div
            className={`${classTitle}-tecnologia-item ${classTitle}-tecnologia-item-equipo`}
          >
            <StaticImage
              src="../../../images/home/tecnologias/Equipo.png"
              alt={`${classTitle}-tecnologia-image`}
              className={`${classTitle}-tecnologia-image`}
              placeholder="blurred"
            />
            <h5>Equipo de trabajo</h5>
            <p>
              Contamos con personal propio y una amplia red de colaboradores
              externos, todos ellos expertos profesionales equipados con
              tecnología de última generación.
            </p>
          </div>
          <div
            className={`${classTitle}-tecnologia-item ${classTitle}-tecnologia-item-soporte`}
          >
            <StaticImage
              src="../../../images/home/tecnologias/Servicio.png"
              alt={`${classTitle}-tecnologia-image`}
              className={`${classTitle}-tecnologia-image`}
              placeholder="blurred"
            />
            <h5>Soporte técnico</h5>
            <p>
              Contamos con personal propio y una amplia red de colaboradores
              externos, todos ellos expertos profesionales equipados con
              tecnología de última generación.
            </p>
          </div>
        </div>

        <CarouselSplide
          classTitle={classTitle}
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
        />

        <div
          className={`${classTitle}-tecnologia-btn-container`}
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <div className={`${classTitle}-tecnologia-btn`}>
            <StaticImage
              src="../../../images/poligonos/circulo-blanco.svg"
              alt="circulo-blanco"
              className="circulo-blanco"
              placeholder="tracedSVG"
            />
            <Link to="/soporte/servicios">
              <button className="text-uppercase">CONOCELOS</button>
            </Link>
          </div>
        </div>
        <StaticImage
          src="../../../images/poligonos/cuadrado-naranja.svg"
          alt="cuadrado-naranja"
          className="cuadrado-naranja"
          placeholder="tracedSVG"
        />
      </section>
    </>
  )
}
